import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDrawerComponent } from 'devextreme-angular';
import config from 'devextreme/core/config';
import { AuthService, User } from './@auth';
import { PathMap } from './@core/enums';
import { SeoService } from './@core/services';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  currentUser!: User;
  user: any;

  @ViewChild(DxDrawerComponent, { static: false }) drawer!: DxDrawerComponent;

  showSubmenuModes: string[] = ['slide', 'expand'];
  positionModes: string[] = ['left', 'right'];
  showModes: string[] = ['push', 'shrink', 'overlap'];
  text!: string;
  selectedOpenMode = 'shrink';
  selectedPosition = 'left';
  selectedRevealMode = 'slide';
  isDrawerOpen = true;
  elementAttr: any;
  navigation = ([] = [
    {
      id: 1,
      text: 'Clientes',
      icon: 'card',
      path: `${PathMap.App}/${PathMap.Administracion}/${PathMap.AdministracionClientes}`,
    },
    {
      id: 2,
      text: 'Grupos',
      icon: 'smalliconslayout',
      path: `${PathMap.App}/${PathMap.Administracion}/${PathMap.AdministracionGrupos}`,
    },
    {
      id: 2,
      text: 'Usuarios',
      icon: 'user',
      path: `${PathMap.App}/${PathMap.Administracion}/${PathMap.AdministracionUsuarios}`,
    },
    {
      id: 3,
      text: 'Parametros',
      icon: 'user',
      path: `${PathMap.App}/${PathMap.Administracion}/${PathMap.AdministracionParametros}`,
    },
  ]);

  optionsUser: any;
  itemsUsuario = [
    {
      value: 1,
      name: 'Cerrar sesión',
      icon: 'runner',
    },
  ];

  toolbarContent = [
    {
      widget: 'dxButton',
      location: 'before',
      options: {
        icon: 'menu',
        onClick: () => (this.isDrawerOpen = !this.isDrawerOpen),
      },
    },
  ];

  constructor(
    private seoService: SeoService,
    private authService: AuthService,
    private router: Router,
    private httpClient: HttpClient
  ) {
    this.authService.currentUser.subscribe((x) => {
      this.user = x ? x.usuario : null;
      this.currentUser = x;
    });
    this.onItemClickUsario = this.onItemClickUsario.bind(this);
    this.onItemClick = this.onItemClick.bind(this);
    config({
      editorStylingMode: 'outlined',
    });
  }

  ngOnInit(): void {
    this.seoService.init();
  }

  onItemClickUsario(e) {
    this.authService.logout();
    this.router.navigate([`/${PathMap.Login}`]);
  }

  onItemClick(e) {
    const { path } = e.itemData;
    window.location.href = path;
    //this.router.navigate([path]);
  }
}
